import { defineComponent as _defineComponent } from 'vue'
import {computed} from 'vue'
import { InviteLinks, DataInstance } from '@busy-human/opt-library'
import VQrCode from '@/components/QrCode.vue'
// import textfield from "@busy-human/vue-component-library/components/text-field.vue"

type Props ={
    selectedLink: DataInstance<InviteLinks.Model>,
}
type Emits = {
    (e: 'closePopup'):void
    (e: 'showToast',from: "share" | "copy" | "embed" | "cantCopy"):void

    (e: 'previewInvite'): void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'meeting-link-share-popup',
  props: {
    selectedLink: null
  },
  emits: ["closePopup", "showToast", "previewInvite"],
  setup(__props: any, { expose, emit }: { emit: ({
    (e: 'closePopup'):void
    (e: 'showToast',from: "share" | "copy" | "embed" | "cantCopy"):void

    (e: 'previewInvite'): void
}), expose: any, slots: any, attrs: any }) {
  expose();

const props = __props as {
    selectedLink: DataInstance<InviteLinks.Model>,
}





const inviteLink = computed(() => {
    if(props.selectedLink) {
        return `${window.location.protocol}//${window.location.host}/#/invite/${props.selectedLink.link}`
    } else return undefined;
})

const closePopup = ()=>{
    emit('closePopup')
}

const handleCopy = async () => {
    if(navigator.clipboard){
        if(inviteLink.value)
            try{
                await navigator.clipboard.writeText(inviteLink.value)
                emit('showToast', 'copy')
            }catch(e){
                alert("something went wrong")
            }
        else
            console.log("No Invite Provided")
    }else
        emit('showToast', 'cantCopy')

    if(ENVIRONMENT === 'development') console.log(inviteLink.value);

    closePopup()
}

const handlePreview = () => {
    emit('previewInvite')
    closePopup()
}

const handleEmbed = async () => {
    if(navigator.clipboard){
        let projectId = ENVIRONMENT == 'development' ? 'leanmeet-optme' : 'opt-beta'
        const KEY_BASE_URL = `https://us-central1-${projectId}.cloudfunctions.net`
        const KEY_INVITE_ID = props.selectedLink.$id
        const KEY_USER_ID = props.selectedLink.payer || props.selectedLink.collector
        
        //TODO: Grab this from the library/util/snippets/optsnippet.js file dynamically
        const jsSnippet = `((e,t,n)=>{const o=\`\${e}/embedInvite/\${t}?user=\${n}&style=basic\`;const c="#invite-embed";async function r(){return fetch(\`\${o}\`).then(e=>{if(e.ok){return e.text()}else{console.warn(\`Unable to fetch \${t}\`);console.warn(e.status,e.statusText)}})}function s(e){const n=document.querySelector(c);if(n){n.innerHTML=e}else{console.warn(\`Unable to inject snippet for \${t}, element not found: \${c}\`)}}function u(){return r().then(e=>{s(e)}).catch(e=>{console.error(e)})}u()})('${KEY_BASE_URL}','${KEY_INVITE_ID}','${KEY_USER_ID}');`;

        const snippet = `<div id="invite-embed"></div><script>${jsSnippet}<\/script>`;

        try{
            await navigator.clipboard.writeText(snippet)
            emit('showToast', 'embed')
        }catch(e){
            alert("something went wrong")
        }
    }else
        emit('showToast', 'cantCopy')

    closePopup()
}



const __returned__ = { props, emit, inviteLink, closePopup, handleCopy, handlePreview, handleEmbed, computed, InviteLinks, DataInstance, VQrCode }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})